import { Component, OnInit } from '@angular/core';
import {RoleService} from '../../services/role.service';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
  selector: 'app-administration',
  templateUrl: './administration.component.html',
  styleUrls: ['./administration.component.css']
})
export class AdministrationComponent implements OnInit {

  navLinks = [
    {path: '/administration/reminders', label: 'Reminders'},
    {path: '/administration/debtors', label: 'Debtors'},
    {path: '/administration/fees', label: 'Fees'},
    {path: '/administration/configs', label: 'Configs'},
    {path: '/administration/users', label: 'Users'},
    {path: '/administration/templates', label: 'Templates'},
    {path: '/administration/images', label: 'Images'},
    {path: '/administration/cashback-groups', label: 'Cashback Groups'},
    {path: '/administration/partner-counter', label: 'B2B Invoicing'},
  ];
  constructor(
    private roleService: RoleService,
    private route: ActivatedRoute,
    private router: Router,
  ) { }

  currentUserIsMarketing(){

    if( this.roleService.hasRoles('marketing') ) {
return true;
}

    return false;

  }

  ngOnInit() {

    if ( this.currentUserIsMarketing() ) {
      this.navLinks = [
        {path: '/administration/configs', label: 'Configs'},
        {path: '/administration/templates', label: 'Templates'},
      ];

      if ( this.router.url === '/administration/reminders') {
this.router.navigate(['administration', 'configs']);
}

    }

  }

}
